import { useEffect, useState } from 'react'
import { useGiftGivers } from 'src/routes/(registry)/registry/(gift-tracker-revamp)/context/GiftGiversProvider'

export const DISMISSED_WELCOME_MODAL_KEY = 'GTWelcomeModalDismissed'

export const useWelcomeModalDismissal = () => {
  const { giftGivers = [], isLoading } = useGiftGivers()
  const [isWelcomeModalDismissed, setWelcomeModalDismissed] = useState(true)
  const [modalWasOpened, setModalWasOpened] = useState(false)

  useEffect(() => {
    const rememberedDismissal =
      window.localStorage.getItem(DISMISSED_WELCOME_MODAL_KEY) === 'true'
    setWelcomeModalDismissed(
      rememberedDismissal ||
        (isWelcomeModalDismissed && modalWasOpened) ||
        (!isLoading && giftGivers.length === 0)
    )
  }, [giftGivers, isLoading, modalWasOpened])

  return {
    isWelcomeModalDismissed,
    setModalWasOpened,
    setWelcomeModalDismissed,
  }
}
